export default __webpack_public_path__ + "static/media/empty-campaign.501e4486.svg";